import axios from "axios"
import _Util from '../helper/_Util'
import { message } from 'antd';

const URI_API = process.env.REACT_APP_URL_API

const getOrg = async () =>{
  try {
      let result = await axios.get(`${URI_API}/master/org`, {withCredentials: true})
      if(result.data.status){
        return result.data.data
      }else{
        message.error(result.data.msg)
        return []
      }
    }catch(err){
     
     _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return []
    }
}

const getUserGroup = async () =>{
  try {
      let result = await axios.get(`${URI_API}/master/usergroup`, {withCredentials: true})
      if(result.data.status){
        return result.data.data
      }else{
        message.error(result.data.msg)
        return []
      }
    }catch(err){
     
     _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return []
    }
}

const getMenus = async () =>{
  try {
      let result = await axios.get(`${URI_API}/master/menus`, {withCredentials: true})
      if(result.data.status){
        return result.data.data
      }else{
        message.error(result.data.msg)
        return []
      }
    }catch(err){
     
     _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return []
    }
}

const getMasterProvince = async () =>{
    try {
        let result = await axios.get(`${URI_API}/master/provinces`, {withCredentials: true})
        if(result.data.status){
          return result.data.data
        }else{
          message.error(result.data.msg)
          return []
        }
      }catch(err){
       
       _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
        return []
      }
}

const getMasterStationByOrgId = async () =>{
  try {
      let result = await axios.get(`${URI_API}/master/stations`, {withCredentials: true})
      if(result.data.status){
        return result.data.data
      }else{
        message.error(result.data.msg)
        return []
      }
    }catch(err){
      

_Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return []
    }
}

const getMasterSensorByOrgIdAndStationId = async (stationId) =>{
  try {
      let result = await axios.get(`${URI_API}/master/sensors?stationId=${stationId}` ,{withCredentials: true})
      if(result.data.status){
        return result.data.data
      }else{
        message.error(result.data.msg)
        return []
      }
    }catch(err){
      

_Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return []
    }
}

const getMasterParameterByOrgIdAndSensorId = async (sensorId) =>{
  try {
    let result = await axios.get(`${URI_API}/master/parameters?sensorId=${sensorId}` ,{withCredentials: true})
      if(result.data.status){
        return result.data.data
      }else{
        message.error(result.data.msg)
        return []
      }
    }catch(err){
      

_Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return []
    }
}

const exports = {
  getOrg,
  getUserGroup,
  getMenus,
  getMasterProvince,
  getMasterStationByOrgId,
  getMasterSensorByOrgIdAndStationId,
  getMasterParameterByOrgIdAndSensorId
}

export default exports